import * as Actions from 'app/store/actions/ctm/aMeasurement.actions';
import { RESET_CTM } from 'app/store/actions/ctm/landing.actions';

const initialState = {
	distanceFromCrossTunnel: [],
    settlementHistory:[],
    threshold:[],
	tunnelDistanceChosen:null,
	nearestPoint:[],
	axis:[],
	infos:[],
	mainChart:[]
};

const aMeasurementReducer = (state = initialState, action) => {
	switch (action.type) {
		case RESET_CTM: {
			return { ...initialState };
		}
		case Actions.SET_MAIN_CHART:{
			return {
				...state,
				mainChart: action.data,
			};
		}
		case Actions.LIST_A_MEASUREMENT_CONSTRUCTION_INFO: {
			return {
				...state,
				infos: action.data,
			};
		}
		case Actions.GET_AXIS: {
			return {
				...state,
				axis: action.data,
			};
		}
		case Actions.GET_NEAREST_POINT: {
			return {
				...state,
				nearestPoint: action.data,
			};
		}
		case Actions.GET_PREV_NEAREST_POINT: {
			return {
				...state,
				nearestPoint: action.data,
			};
		}
		case Actions.GET_NEXT_NEAREST_POINT: {
			return {
				...state,
				nearestPoint: action.data,
			};
		}
		case Actions.LIST_A_MEASUREMENT_DISTANCE_FROM_CROSS_SECTION_TUNNEL: {
			return {
				...state,
				distanceFromCrossTunnel: action.data,
			};
		}
        case Actions.LIST_A_MEASUREMENT_SETTLEMENT_HISTORY: {
			return {
				...state,
				settlementHistory: action.data,
			};
		}
        case Actions.GET_A_MEASUREMENT_THRESHOLD: {
			return {
				...state,
				threshold: action.data,
			};
		}
        case Actions.UPDATE_A_MEASUREMENT_THRESHOLD: {
			return {
				...state,
				//threshold: action.data,
			};
		}
		case Actions.SET_MEASUREMENT: {
			return {
				...state,
				tunnelDistanceChosen: action.data,
			};
		}
		default: {
			return state;
		}
	}
};

export default aMeasurementReducer;
